import type { UnderwriterSearchRequestQueryWithOutOfOffice } from './underwriter.helpers';

export const underwriterQueryKey = {
  search: ['underwriters'] as const,
  searchWithParams: (params: UnderwriterSearchRequestQueryWithOutOfOffice) =>
    [...underwriterQueryKey.search, params] as const,
};
